import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Button from '../ui/Button'
import Chip from '../ui/Chip'
import InfoCircleOutlineIcon from '../ui/icons/InfoCircleOutlineIcon'

const WRAPPER = 'tw:sticky tw:bottom-0 tw:z-30 tw:w-full tw:bg-white '
  + 'tw:border-t tw:border-solid tw:border-gray-200 '
  + 'tw:flex tw:items-center tw:justify-between tw:gap-4 tw:px-6 tw:py-4'

const SaveFooter = ({ submitText, disabled, dirty, onSave, onCancel }) => {
  if (typeof document === 'undefined')
    return null

  const target = document.querySelector('.content') || document.body
  if (!target)
    return null

  const content = (
    <div className={WRAPPER}>
      {dirty ? (
        <Chip variant="warning" className="tw:gap-1">
          <InfoCircleOutlineIcon className="tw:h-3.5 tw:w-3.5 tw:shrink-0" />
          <span>Les modifications ne sont pas enregistrées</span>
        </Chip>
      ) : <span />}
      <div className="tw:flex tw:items-center tw:gap-2">
        <Button variant="neutral" onClick={onCancel}>Annuler</Button>
        <Button variant="primary" disabled={disabled} onClick={onSave}>
          {submitText}
        </Button>
      </div>
    </div>
  )

  return ReactDOM.createPortal(content, target)
}

SaveFooter.propTypes = {
  dirty: PropTypes.bool,
  disabled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired
}

SaveFooter.defaultProps = {
  dirty: false,
  disabled: false
}

export default SaveFooter
